export class J3SideNavPanel extends EventTarget{
    prevDiv;
    nextDiv;

    constructor(debugLvl = 0, public name = '', enable=true, targetID:string, prevFile:string, nextFile:string){
        super();
        const elem = document.querySelector('#' + targetID) as HTMLElement;
        if(elem){
            if(enable){
                //elem.innerHTML = '';    //子要素をすべて削除
                //PREVボタン
                //const prevHTML = '<div class="left_section hover"><figure><button type="button" id="btn_prev"><img src="' + prevFile + '" alt="Prev"></button></figure></div>';
                this.prevDiv = document.createElement('div');
                this.prevDiv.classList.add('left_section');
                this.prevDiv.classList.add('hover');
                const prevFig = document.createElement('figure');
                const prevButton = document.createElement('button');
                prevButton.type = 'button';
                prevButton.setAttribute('id','btn_prev');
                const prevImg = document.createElement('img');
                prevImg.src = prevFile;
                prevButton.appendChild(prevImg);
                prevFig.appendChild(prevButton);
                this.prevDiv.appendChild(prevFig);
                elem.appendChild(this.prevDiv);
                prevButton.addEventListener("click", (e: Event) => {this.PrevClicked(true)});

                //NEXTボタン
                //const nextHTML = '<div class="right_section hover"><figure><button type="button" id="btn_next"><img src="' + nextFile + '" alt="Next"></button></figure></div>';
                this.nextDiv = document.createElement('div');
                this.nextDiv.classList.add('right_section');
                this.nextDiv.classList.add('hover');
                const nextFig = document.createElement('figure');
                const nextButton = document.createElement('button');
                nextButton.type = 'button';
                nextButton.setAttribute('id','btn_next');
                const nextImg = document.createElement('img');
                nextImg.src = nextFile;
                nextButton.appendChild(nextImg);
                nextFig.appendChild(nextButton);
                this.nextDiv.appendChild(nextFig);
                elem.appendChild(this.nextDiv);
                nextButton.addEventListener("click", (e: Event) => {this.NextClicked(true)});
                //elem.innerHTML = prevHTML + nextHTML;
            }else{
                elem.style.display = 'None';
            }
        }
    }

    PrevClicked(evt){
        const event = new CustomEvent("clicked", { detail: { type:'prev' } });
        this.dispatchEvent(event)
    }
    NextClicked(evt){
        const event = new CustomEvent("clicked", { detail: { type:'next' } });
        this.dispatchEvent(event)
    }

    DummyMethod(){
        console.log('J3SideNavPanel');
    }

    AtMin(){
        //最小インデックス時
        this.prevDiv.style.display = 'none';
        this.nextDiv.style.display = 'block';
    }
    AtMax(){
        //最大インデックス時
        this.prevDiv.style.display = 'block';
        this.nextDiv.style.display = 'none';
    }
    InMid(){
        //非最小・非最大インデックス時
        this.prevDiv.style.display = 'block';
        this.nextDiv.style.display = 'block';
    }
}